import * as React from 'react';

import {colors} from '../colors/colors';
import {CursorRegularIcon} from '../icon/svg/cursor-regular-icon';
import {Illustration} from '../illustrations/illustration';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import type {RequiredAction} from './types';

import styles from './tour.module.css';

type Props = {
    stepNumber: number;
    totalSteps: number;
    title: string;
    description?: string;
    requiredAction?: RequiredAction;
    illustration?: string;
};

export function TourStepContent(props: Props) {
    return (
        <Stack spacing={8}>
            {props.illustration ? (
                <div className={styles.illustration}>
                    <Illustration src={props.illustration} width={248} height={168} />
                </div>
            ) : null}
            <Body size='small' color='dark'>
                {`${props.stepNumber} of ${props.totalSteps}`}
            </Body>
            <Body isBold={true} color='dark'>
                {props.title}
            </Body>
            {props.description && (
                <Body size='small' color='light'>
                    {props.description}
                </Body>
            )}
            {props.requiredAction && (
                <Stack spacing={4} isHorizontal={true} alignItems='start'>
                    <div className={styles['action-icon']}>
                        <CursorRegularIcon
                            size={16}
                            // @ts-expect-error
                            color={colors.blue}
                            wrapWithDiv={true}
                            alignCenter={true}
                        />
                    </div>
                    <Body size='small' color='blue' isBold={true}>
                        {props.requiredAction.guidanceText}
                    </Body>
                </Stack>
            )}
        </Stack>
    );
}
